module.exports = __webpack_public_path__ + "static/media/coreteam03.34edb85d.png";